var config = {
  apiKey: 'AIzaSyDv0oYqiJWlYisXY456n4UnRRpH8-02294',
  authDomain: 'pollscape-d2b4b.firebaseapp.com',
  databaseURL: 'https://pollscape-d2b4b.firebaseio.com',
  projectId: 'pollscape-d2b4b',
  storageBucket: 'pollscape-d2b4b.appspot.com',
  messagingSenderId: '525253815110'
}

export default config



// WEBPACK FOOTER //
// ./src/services/firebaseConfig.js